import React from 'react';
import Foodmenu from '../components/Foodmenu';
import MenuHero from '../components/MenuHero';
import FoodGallery from '../components/Foodgallery';

const Menu = () => {
  return (
    <div>
      <MenuHero/>
        <Foodmenu />
      <FoodGallery/>
    </div>
  );
};

export default Menu;
